/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastScheduleDto } from '../../models/broadcast-schedule-dto';

export interface BroadcastScheduleControllerCancelV1$Params {
  id: string;
}

export function broadcastScheduleControllerCancelV1(http: HttpClient, rootUrl: string, params: BroadcastScheduleControllerCancelV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, broadcastScheduleControllerCancelV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BroadcastScheduleDto>;
    })
  );
}

broadcastScheduleControllerCancelV1.PATH = '/api/v1/broadcast-schedule/{id}/cancel';
